module.exports = __webpack_public_path__ + "img/tab-status-selected.f321f5c3.png";